import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { DashboardSeriesParams, dashboardSeriesResponseSchema } from '../types';

export const createGetDashboardSeriesQuery = () =>
	createAuthQuery({
		params: declareParams<DashboardSeriesParams>(),
		request: {
			method: 'GET',
			url: '/dashboard/series',
			query: ({ metrics, period, timeZone, currency, accountIds }) => ({
				metrics: [...metrics],
				period,
				timeZone,
				currency,
				accountIds: accountIds?.length ? accountIds.map(String) : undefined,
			}),
		},
		response: {
			contract: zodContract(dashboardSeriesResponseSchema),
		},
	});
